import React from 'react'
import "./skillcard.css"
const Skillcard = ({carddata}) => {
  return (
    <article className="skillcard">
        <div className="skillcard-wrapper">
            <img src={carddata.cardImage} alt="" />
            <p>{carddata.title}</p>
        </div>
    </article>
  )
}

export default Skillcard